var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnacleWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232.3,
    height: 37.28,
    viewBox: "0 0 232.3 37.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M110.14,251.06H145.4l-17.84-36.01Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 -215.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,216.12H14.66c3.19,0,5.58.94,7.17,2.84s2.39,4.59,2.39,8.08-.86,6.4-2.6,8.42-4.38,3.03-7.93,3.03H8.87v13.2H0V216.12Zm8.86,15.16h2.16a4.749,4.749,0,0,0,3.58-1.1,4.013,4.013,0,0,0,1.03-2.82,4.448,4.448,0,0,0-.9-2.84q-.885-1.17-3.36-1.17H8.86v7.93h0Zm20.32-15.16h8.84v35.57H29.18V216.12Zm15.22,0h8.24L63.38,235.8V216.12h8.31v35.57H63.38L52.69,232.16v19.53H44.4V216.12h0Zm33.21,0h8.24L96.59,235.8V216.12h8.31v35.57H96.59L85.9,232.16v19.53H77.61V216.12h0Zm92.04,21.04,7.73,2.92a20.3,20.3,0,0,1-2.45,6.77,11.483,11.483,0,0,1-4.16,4.1,12.763,12.763,0,0,1-6.31,1.38,15.223,15.223,0,0,1-7.6-1.68,13.647,13.647,0,0,1-5.1-5.94,24.2,24.2,0,0,1-2.14-10.87q0-8.835,3.77-13.57t10.66-4.75c3.59,0,6.42.9,8.48,2.72s3.59,4.6,4.58,8.35l-7.79,2.16a9.53,9.53,0,0,0-.86-2.39,5.658,5.658,0,0,0-1.81-1.94,4.333,4.333,0,0,0-2.4-.68,4.987,4.987,0,0,0-4.59,3.01c-.8,1.49-1.21,3.83-1.21,7.02,0,3.95.49,6.65,1.44,8.12a4.558,4.558,0,0,0,4.05,2.19,4.391,4.391,0,0,0,3.83-1.77,12.334,12.334,0,0,0,1.88-5.14h0Zm12.01-21.04h8.82v26.81h13.76v8.76H181.65V216.12h0Zm26.58,0h23.63v7.59H217.08v5.66H230.8v7.26H217.08v7.01H232.3v8.06H208.24V216.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M110.14,251.06H145.4l-17.84-36.01Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1-2",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 225.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 227.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 229.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 231.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 234.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 236.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 239.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 240.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 32.24,
    height: 0.81,
    transform: "translate(111.65 242.53)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnacleWhiteLogo);
export default __webpack_public_path__ + "static/media/pinnacleWhiteLogo.0ccf090c2b64dcf889860b771c1518ae.svg";
export { ForwardRef as ReactComponent };